var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#282830",
    fillRule: "evenodd",
    d: "M4 8.43C4 5.15 6.69 2.5 10 2.5s6 2.66 6 5.93c0 1.31 0 2.07-1 3.57s-3.28 4.39-4.44 5.27l-.03.02c-.17.14-.26.21-.54.21-.261 0-.357-.07-.515-.185l-.035-.025-.02-.02C8.26 16.4 6 13.5 5 12S4 9.74 4 8.43m8.22 5.94c.83-1.01 1.63-2.09 2.11-2.81h.01c.46-.69.66-1.17.76-1.59.1-.44.1-.87.1-1.54 0-2.83-2.32-5.13-5.2-5.13S4.8 5.6 4.79 8.45c0 .67 0 1.09.1 1.53.1.42.3.89.76 1.59.48.73 1.28 1.8 2.1 2.81.84 1.02 1.64 1.9 2.13 2.27l.03.02.04.04h.03l.02-.02.04-.03.03-.02c.5-.37 1.31-1.24 2.15-2.27M7 8c0-1.66 1.34-3 3-3s3 1.34 3 3-1.34 3-3 3-3-1.34-3-3m.8 0c0 1.22.98 2.2 2.2 2.2s2.2-.98 2.2-2.2-.98-2.2-2.2-2.2-2.2.98-2.2 2.2",
    clipRule: "evenodd"
  })));
};
export default SvgPin;